export function getConfigValue(name: string): any {
    let domElement = $(`[data-config-name='${name}']`);

    if (domElement.length > 0) {
        return domElement.data('value');
    }

    return null;
}

export function getDomElementByConfig<TElement extends HTMLElement>(name: string): TElement {
    let id = getConfigValue(name);

    return document.getElementById(id) as TElement;
}
